import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'idp-close-header-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './close-header-button.component.html',
  styleUrls: ['./close-header-button.component.scss']
})
export class CloseHeaderButtonComponent {
  @Output() closeHeader = new EventEmitter();
}
